var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonDropdown',{attrs:{"label":_vm.labelCounter}},[_c('div',{staticClass:"q-pa-md"},[_c('q-option-group',{attrs:{"type":"checkbox","label":_vm.label,"value":_vm.value,"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }